import { render, staticRenderFns } from "./show-model.vue?vue&type=template&id=76bcfdcc&scoped=true&"
import script from "./show-model.vue?vue&type=script&lang=js&"
export * from "./show-model.vue?vue&type=script&lang=js&"
import style0 from "./show-model.vue?vue&type=style&index=0&id=76bcfdcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bcfdcc",
  null
  
)

export default component.exports